'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _Preloader = require('./Preloader');

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PreloaderGlobal: {
        displayName: 'PreloaderGlobal'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Preloader/PreloaderGlobal.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var globalShow = 'on'; //on Показывать, one_show показать один раз, off не показывать

var PreloaderGlobal = _wrapComponent('PreloaderGlobal')((_dec = (0, _reactRedux.connect)(function (state) {
    return { show_preloader: state.preloader.show };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(PreloaderGlobal, _Component);

    function PreloaderGlobal() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PreloaderGlobal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PreloaderGlobal.__proto__ || (0, _getPrototypeOf2.default)(PreloaderGlobal)).call.apply(_ref, [this].concat(args))), _this), _this.show = function () {
            if (globalShow == 'off') {
                return false;
            }
            if (globalShow == 'one_show') {
                globalShow = 'off';
            }
            return _this.props.show_preloader;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PreloaderGlobal, [{
        key: 'render',
        value: function render() {
            var show_preloader = this.props.show_preloader;


            return _react3.default.createElement(
                _Preloader2.default,
                { preload: this.show() },
                this.props.children
            );
        }
    }]);
    return PreloaderGlobal;
}(_react2.Component), _class2.propTypes = {
    show_preloader: _react2.PropTypes.bool.isRequired
}, _class2.toogleShow = function () {
    var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'on';

    globalShow = show;
}, _temp2)) || _class));

exports.default = PreloaderGlobal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Preloader/PreloaderGlobal.jsx
// module id = 1735
// module chunks = 0